import { OriginApp } from '@wix/wix-help-widget-common/types';

import { IRenderModel } from '../../types';
import { Platform } from '../../types/model';
import { createFedopsLogger } from './fedops';
import { isSupportChatOrigins } from './isSupportChatOrigins';
import { logger } from './logger';

export const fedopsLogger = createFedopsLogger();

const getInitialData = (): IRenderModel => {
  try {
    const script = document.getElementById('ssr-initial-data')!;
    return JSON.parse(script.textContent ?? '');
  } catch (error) {
    logger.error({
      message: 'fail parse initial data',
      error,
    });
    throw error;
  }
};

class RenderModel {
  private readonly model: IRenderModel;

  constructor() {
    this.model = getInitialData();
  }

  get() {
    return this.model;
  }

  getLocale() {
    return this.model?.locale;
  }

  getUserId() {
    return this.model?.userId;
  }

  getAccountId() {
    return this.model?.accountId;
  }

  getUserContext() {
    return this.model?.userContext;
  }

  getExperiments() {
    return this.model?.experiments;
  }

  getWixBrand() {
    return this.model?.wixBrand;
  }

  getQueryParams() {
    return this.model?.queryParams;
  }

  isInvokedFromHeader() {
    return this.getQueryParams().isInvokedFromHeader === 'true';
  }

  isStudioBrand() {
    return this.getQueryParams().brand === 'WixStudio';
  }

  provideRuntimeDataFromSDK() {
    return this.getQueryParams().provideRuntimeDataFromSDK === 'true';
  }

  isFullWidth() {
    return this.model?.isFullWidth ?? this.getQueryParams().fullWidth === 'true';
  }

  isLandingPage(): boolean {
    const originQuery = this.getQueryParams().origin;
    return isSupportChatOrigins(originQuery) && originQuery === 'Landing';
  }

  isStudioEditor(): boolean {
    const originQuery = this.getQueryParams().origin;
    return originQuery === OriginApp.StudioEditor;
  }

  isEditor(): boolean {
    const originQuery = this.getQueryParams().origin;
    return originQuery === 'Editor';
  }

  isEditor3(): boolean {
    const originQuery = this.getQueryParams().origin;
    return originQuery === 'Editor3';
  }

  isBlocks(): boolean {
    const originQuery = this.getQueryParams().origin;
    return originQuery === 'Blocks';
  }

  hideWixHeader(): boolean {
    return (
      this.getQueryParams()?.referral === 'hoppbywix' ||
      this.model.isHideWixHeader === true ||
      this.model.platform === Platform.MOBILE_NATIVE_APP
    );
  }

  isWidget(): boolean {
    return this.model?.isWidget;
  }

  isMobile(): boolean {
    return (
      this.model?.platform === Platform.MOBILE_NATIVE_APP || this.model?.platform === Platform.MOBILE_WEB
    );
  }

  isCopilot(): boolean {
    return this.model?.isCopilot;
  }
}

export const renderModel = new RenderModel();
